import React from 'react';
import { CrosshairIcon, CheckCircleIcon, AlertTriangleIcon } from 'lucide-react';
const indoorRangeRules = ['Maximum caliber: .45 ACP for handguns. Rifle calibers up to .223/5.56 NATO only.', 'NO magnum rounds allowed (e.g., .357 Mag, .44 Mag, .357 SIG).', 'NO steel core, armor piercing, incendiary, or tracer ammunition.', 'NO shotguns on the indoor range.', 'Shoot only at your own target in your own lane.', 'Do not shoot at target frames, carriers, ceiling, floor, or walls.', 'All shots must impact the backstop/bullet trap.', 'Maximum of 2 shooters per lane.'];
export function IndoorRangeRules() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2890">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2891">
        <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1e3d2f'
      }} data-id="element-2892">
          Indoor Pistol/Rifle Range Rules
        </h2>
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2893">
          <div className="p-4 flex items-center gap-3" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-2894">
            <CrosshairIcon size={20} style={{
            color: '#c8a84b'
          }} data-id="element-2895" />
            <h3 className="text-base font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-2896">
              Indoor Range Specific Rules
            </h3>
          </div>
          <div className="p-6 md:p-8 space-y-4" data-id="element-2897">
            {indoorRangeRules.map((rule, index) => <div key={index} className="flex items-start gap-3" data-id="element-2898">
                <CheckCircleIcon size={18} className="flex-shrink-0 mt-0.5" style={{
              color: '#1e3d2f'
            }} data-id="element-2899" />
                <p className="text-base text-gray-800" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2900">
                  {rule}
                </p>
              </div>)}
          </div>

          {/* Ammo Warning */}
          <div className="p-4 border-t flex items-start gap-3" style={{
          backgroundColor: '#fffbeb',
          borderColor: '#ede9e0'
        }} data-id="element-2901">
            <AlertTriangleIcon size={20} className="flex-shrink-0 mt-0.5" style={{
            color: '#c8a84b'
          }} data-id="element-2902" />
            <p className="text-sm font-medium" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2903">
              <strong data-id="element-2904">NO magnum ammunition</strong> is allowed on the indoor
              range. This includes .357 Magnum, .44 Magnum, .357 SIG, and
              similar high-pressure cartridges.
            </p>
          </div>
        </div>
      </div>
    </div>;
}